import { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../home/components/Footer';

const values = [
  {
    icon: 'ri-shield-check-line',
    title: 'Quality First',
    description:
      'We never compromise on quality. Every product undergoes rigorous testing and quality checks to meet international standards.',
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'Trust & Transparency',
    description:
      'Building long-term relationships through honest communication, fair pricing, and reliable delivery commitments.',
  },
  {
    icon: 'ri-leaf-line',
    title: 'Sustainability',
    description:
      'Committed to eco-friendly practices and supporting farmers who use sustainable agricultural methods.',
  },
  {
    icon: 'ri-award-line',
    title: 'Excellence',
    description:
      'Constantly innovating and improving our processes to deliver exceptional value to our partners worldwide.',
  },
];

const team = [
  {
    name: 'Reena Patil',
    title: 'Director - New Businesses and Expansion',
    image:
      'https://public.readdy.ai/ai/img_res/4b89350322afd106ca5100fc9fc7ad07.jpg',
  },
  {
    name: 'Samuel M',
    title: 'Operations Manager',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20Indian%20businessman%20operations%20manager%20in%20formal%20suit%20with%20friendly%20expression%20in%20modern%20corporate%20office%20with%20natural%20lighting%20clean%20white%20background%20executive%20portrait&width=400&height=400&seq=team-002&orientation=squarish',
  },
];

const certifications = [
  { name: 'ISO 9001:2015', icon: 'ri-award-line' },
  { name: 'FSSAI Certified', icon: 'ri-shield-check-line' },
  { name: 'Export License', icon: 'ri-plane-line' },
  { name: 'Organic Certified', icon: 'ri-leaf-line' },
];

export default function AboutPage() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="relative min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
        <div className="px-4 sm:px-8 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2 sm:gap-3">
              <img
                src="https://static.readdy.ai/image/d9bb5601c98f22586a2b11870925187d/b857441a8282eff6e67d45b8b6cd5de0.jpeg"
                alt="Horizon Pathways Logo"
                className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
              />
              <span className="text-base sm:text-xl font-semibold text-gray-900">
                Horizon Pathways
              </span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-8">
              <Link
                to="/"
                className="text-sm font-medium text-gray-700 transition-colors hover:text-emerald-600 whitespace-nowrap"
              >
                Home
              </Link>
              <Link
                to="/products"
                className="text-sm font-medium text-gray-700 transition-colors hover:text-emerald-600 whitespace-nowrap"
              >
                Products
              </Link>
              <Link
                to="/services"
                className="text-sm font-medium text-gray-700 transition-colors hover:text-emerald-600 whitespace-nowrap"
              >
                Services
              </Link>
              <Link
                to="/about"
                className="text-sm font-medium text-emerald-600 border-b-2 border-emerald-600 whitespace-nowrap"
              >
                About
              </Link>
              <Link
                to="/contact"
                className="text-sm font-medium text-gray-700 transition-colors hover:text-emerald-600 whitespace-nowrap"
              >
                Contact
              </Link>
            </div>

            {/* Right Side */}
            <div className="flex items-center gap-3 sm:gap-4">
              <Link
                to="/contact"
                className="hidden sm:block px-4 sm:px-6 py-2 border-2 border-emerald-600 text-emerald-600 rounded-full text-sm font-medium transition-all hover:bg-emerald-600 hover:text-white whitespace-nowrap"
              >
                Get Quote
              </Link>

              {/* Mobile Menu Button */}
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="md:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer"
                aria-label="Toggle menu"
              >
                <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        ></div>
      )}

      {/* Mobile Menu */}
      <div
        className={`fixed top-0 right-0 h-full w-64 bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out md:hidden ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col h-full">
          {/* Mobile Menu Header */}
          <div className="flex items-center justify-between px-6 py-5 border-b border-gray-200">
            <span className="text-lg font-semibold text-gray-900">Menu</span>
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              className="w-8 h-8 flex items-center justify-center text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer"
              aria-label="Close menu"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
          </div>

          {/* Mobile Menu Links */}
          <div className="flex-1 overflow-y-auto py-6">
            <div className="flex flex-col space-y-1 px-4">
              <Link
                to="/"
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-4 py-3 text-base font-medium text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg transition-colors cursor-pointer"
              >
                Home
              </Link>
              <Link
                to="/products"
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-4 py-3 text-base font-medium text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg transition-colors cursor-pointer"
              >
                Products
              </Link>
              <Link
                to="/services"
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-4 py-3 text-base font-medium text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg transition-colors cursor-pointer"
              >
                Services
              </Link>
              <Link
                to="/about"
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-4 py-3 text-base font-medium text-emerald-600 bg-emerald-50 rounded-lg cursor-pointer"
              >
                About
              </Link>
              <Link
                to="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-4 py-3 text-base font-medium text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg transition-colors cursor-pointer"
              >
                Contact
              </Link>
            </div>

            {/* Mobile Menu CTA */}
            <div className="px-4 mt-6">
              <Link
                to="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block w-full px-6 py-3 bg-emerald-600 text-white text-center rounded-full text-base font-medium hover:bg-emerald-700 transition-all whitespace-nowrap cursor-pointer"
              >
                Get Quote
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="relative pt-24 sm:pt-28 md:pt-32 pb-12 sm:pb-16 md:pb-20 px-4 sm:px-6 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center">
            <div>
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
                Connecting India's Finest Agricultural Products to the World
              </h1>
              <p className="text-sm sm:text-base md:text-lg text-gray-600 mb-6 sm:mb-8 leading-relaxed">
                Horizon Pathways is a trusted bridge between Indian agriculture and global markets. We're passionate about delivering premium quality products while empowering farming communities and building lasting partnerships worldwide.
              </p>
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4">
                <Link
                  to="/contact"
                  className="px-6 sm:px-8 py-2.5 sm:py-3 bg-emerald-600 text-white rounded-full text-sm font-medium transition-all hover:bg-emerald-700 whitespace-nowrap cursor-pointer text-center"
                >
                  Partner With Us
                </Link>
                <Link
                  to="/products"
                  className="px-6 sm:px-8 py-2.5 sm:py-3 border-2 border-gray-300 text-gray-700 rounded-full text-sm font-medium transition-all hover:border-emerald-600 hover:text-emerald-600 whitespace-nowrap cursor-pointer text-center"
                >
                  View Products
                </Link>
              </div>
            </div>
            <div className="rounded-xl sm:rounded-2xl overflow-hidden shadow-lg sm:shadow-xl w-full h-64 sm:h-80 md:h-96">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20agricultural%20export%20company%20office%20environment%20with%20diverse%20international%20team%20working%20together%20on%20global%20trade%20operations%20professional%20workspace%20with%20world%20map%20computers%20organized%20workspace%20representing%20successful%20import%20export%20business%20warm%20natural%20lighting%20professional%20photography&width=600&height=400&seq=about-hero-001&orientation=landscape"
                alt="Horizon Pathways Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-12">
            <div className="bg-gradient-to-br from-emerald-50 to-white p-6 sm:p-8 md:p-10 rounded-xl sm:rounded-2xl">
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-emerald-600 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                <i className="ri-focus-3-line text-white text-2xl sm:text-3xl"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">
                Our Mission
              </h2>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                To be the most trusted partner in agricultural exports by delivering premium quality products, exceptional service, and building sustainable relationships that benefit farmers, clients, and communities across the globe.
              </p>
            </div>
            <div className="bg-gradient-to-br from-amber-50 to-white p-6 sm:p-8 md:p-10 rounded-xl sm:rounded-2xl">
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-amber-600 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                <i className="ri-eye-line text-white text-2xl sm:text-3xl"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">
                Our Vision
              </h2>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                To become a global leader in agricultural exports, recognized for innovation, sustainability, and excellence. We envision a world where Indian agriculture reaches every corner of the globe, enriching lives and creating prosperity.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 sm:mb-12 md:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Our Core Values
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
              The principles that guide every decision we make and every relationship we build
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="bg-white p-6 sm:p-8 rounded-xl sm:rounded-2xl hover:shadow-lg transition-shadow cursor-pointer"
              >
                <div className="w-12 h-12 sm:w-14 sm:h-14 bg-emerald-100 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                  <i className={`${value.icon} text-emerald-600 text-xl sm:text-2xl`}></i>
                </div>
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">
                  {value.title}
                </h3>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 sm:mb-12 md:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Meet Our Leadership Team
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-600">
              Passionate experts dedicated to your success
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 max-w-5xl mx-auto">
            {team.map((member, index) => (
              <div
                key={index}
                className="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 hover:shadow-xl transition-shadow cursor-pointer"
              >
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-1">
                  {member.name}
                </h3>
                <div className="text-xs sm:text-sm text-emerald-600 font-medium mb-2 sm:mb-3">
                  {member.role}
                </div>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                  {member.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Certifications Section */}
      <section id="certifications" className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 sm:mb-12 md:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Certifications & Compliance
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-600">
              Committed to the highest standards of quality and safety
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 sm:gap-6">
            {certifications.map((cert, index) => (
              <div
                key={index}
                className="bg-white border-2 border-gray-200 p-4 sm:p-6 rounded-lg sm:rounded-xl hover:border-emerald-600 hover:shadow-md transition-all cursor-pointer text-center"
              >
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className={`${cert.icon} text-emerald-600 text-lg sm:text-xl`}></i>
                </div>
                <div className="text-xs sm:text-sm font-medium text-gray-900">
                  {cert.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8 bg-gradient-to-r from-emerald-600 to-emerald-700">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4 sm:mb-6">
            Ready to Partner With Us?
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-emerald-50 mb-6 sm:mb-8 leading-relaxed px-4">
            Join hundreds of satisfied clients worldwide who trust Horizon Pathways for their agricultural export needs. Let's grow together.
          </p>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-4">
            <Link
              to="/contact"
              className="px-6 sm:px-8 py-2.5 sm:py-3 bg-white text-emerald-600 rounded-full text-sm font-medium transition-all hover:bg-gray-100 whitespace-nowrap cursor-pointer text-center"
            >
              Get in Touch
            </Link>
            <Link
              to="/products"
              className="px-6 sm:px-8 py-2.5 sm:py-3 border-2 border-white text-white rounded-full text-sm font-medium transition-all hover:bg-white hover:text-emerald-600 whitespace-nowrap cursor-pointer text-center"
            >
              Browse Products
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
}
